(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	require('slick-carousel');

	var mod = $('#roles-slideshow').find('div.roles');

	$(window).load(function () {
		mod.slick({
			dots: true,
			arrows: true,
			slidesToShow: 3,
			slidesToScroll: 3,
			responsive: [
				{
					breakpoint: 759,
					settings: {
						slidesToScroll: 2,
						slidesToShow: 2
					}
				},
				{
					breakpoint: 479,
					settings: {
						slidesToScroll: 1,
						slidesToShow: 1
					}
				}
			],
			infinite: true,
			speed: 200,
			autoplay: false,
			adaptiveHeight: true,
			prevArrow: '<a role="button" class="slick-prev icon-left icon--round icon--round--transparent"></a>',
			nextArrow: '<a role="button" class="slick-next icon-right icon--round icon--round--transparent"></a>'
		});
	});
})();
